<template>
  <div class="order-parent-from">
    <el-divider content-position="left">订单来源分类列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchClassifis"
          :key="searchCompany.id"
          :label="searchCompany.name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="small" @click="handleIn">录入</el-button>
        <el-button
          type="primary"
          size="small"
          @click.native="$router.push('order_platform')"
          >返回上一级</el-button
        >
      </div>
    </div>

    <el-drawer
      title="录入/编辑"
      :visible.sync="addAndEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="classifyForm"
          :rules="rules"
          ref="classifyForm"
          label-width="100px"
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="classifyForm.name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="classifyForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="handleSubmit('classifyForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>

    <el-table
      height="calc(100vh - 280px)"
      :data="data"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="handleEdit(scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderParentFrom",
  data() {
    return {
      direction: "rtl",
      searchArr: {
        id: "",
      },
      npage: 1,
      categoryPerPage: 30,
      total: null,

      listSortForm: [],
      data: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchClassifis: [],
      addAndEditDrawer: false,
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: "",
      classifyForm: {
        id: "",
        name: "",
        display: false,
      },
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.loadTable();
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    loadTable() {
      this.$axios
        .get("api/admin/order_parent_from/index", {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.data = data.data.data;
            this.total = data.data.total;
            this.loadRadio();
            this.loadSort();
          }
        })
        .catch();
    },
    handleEdit(row) {
      this.classifyForm.id = row.id;
      this.classifyForm.name = row.name;
      this.classifyForm.display = row.display === 1 ? false : true;
      this.addAndEditDrawer = true;
    },
    handleClose() {
      this.classifyForm.id = '';
      this.classifyForm.name = '';
      this.classifyForm.display = false;
      this.addAndEditDrawer = false;
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("api/admin/order_parent_from/store", {
              id: this.classifyForm.id,
              name: this.classifyForm.name,
              display: this.classifyForm.display === false ? 1 : 0,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                // this.$refs.classifyForm.resetFields();
                this.classifyForm.id = '';
                this.classifyForm.name = '';
                this.addAndEditDrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    loadRadio() {
      this.data.map((item) => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false;
        } else {
          this.ListIfDisplay[item.id] = true;
        }
      });
    },
    loadSort() {
      this.data.map((item) => {
        this.listSort[item.id] = Number(item.sort);
      });
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    handleSizeChange(val) {
      this.categoryPerPage = val;
      this.loadTable();
    },
    searchRemoteCfcategory(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchClassifis = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/admin/order_parent_from/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchClassifis = data.data;
          }
        })
        .catch();
    },
    handleSearchCfcategory(query) {
      this.searchArr.id = query;
      setTimeout(() => {
        this.loadTable();
      });
    },
    handleIn() {
      this.addAndEditDrawer = true;
    },
    editListRadio(row) {
      this.$axios
        .put("api/admin/order_parent_from/listshow", {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    setSort(row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error("排序值为数字！");
        return false;
      }
      this.$axios
        .put("api/admin/order_parent_from/setsort", {
          id: row.id,
          sort: this.listSort[row.id],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
  },
};
</script>

<style scoped>
.order-parent-from {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/OrderParentFrom.vue